import { defaultRowsPerPage, defaultRowsPerPageOptions } from '@juvare/common-data-table-ui/DataTable';
import { Box, TablePagination } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
export const ListPagination = ({ filteredRowCount, page, rowsPerPage, rowsPerPageOptions, onPageChange, onRowsPerPagePageChange, }) => {
    const { t } = useAlertUiTranslation();
    if (filteredRowCount != null && filteredRowCount > 0 && page != null && rowsPerPage != null) {
        return (React.createElement(Box, { p: 2, pt: 0, pb: 1 },
            React.createElement(TablePagination, { component: 'div', page: page, count: filteredRowCount, rowsPerPage: rowsPerPage !== null && rowsPerPage !== void 0 ? rowsPerPage : defaultRowsPerPage, rowsPerPageOptions: rowsPerPageOptions !== null && rowsPerPageOptions !== void 0 ? rowsPerPageOptions : defaultRowsPerPageOptions, onPageChange: (event, page) => {
                    if (onPageChange) {
                        onPageChange(page);
                    }
                }, onRowsPerPageChange: (event) => {
                    if (onRowsPerPagePageChange) {
                        onRowsPerPagePageChange(parseInt(event.target.value, 10));
                    }
                }, labelRowsPerPage: t('common.pageSize'), sx: {
                    '& .MuiToolbar-root': {
                        p: 0,
                    },
                    '& .MuiTablePagination-spacer': {
                        display: 'none',
                    },
                    '& .MuiTablePagination-input': {
                        mr: 2,
                    },
                    '& .MuiTablePagination-displayedRows': {
                        flexGrow: 1,
                        textAlign: 'right',
                    },
                } })));
    }
    else {
        return null;
    }
};
